declare namespace $ {

	type $mol_view__sub_bog_builderui_toast_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_toast_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_builderui_toast_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_builderui_toast extends $bog_builderui_div {
		Dot( ): $mol_view
		Title( ): $mol_view
		Text( ): $mol_view
		Texts( ): $mol_view
		kind( ): string
		title( ): string
		text( ): string
		attr( ): ({ 
			'bog_builderui_toast_kind': ReturnType< $bog_builderui_toast['kind'] >,
		}) 
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=toast.view.tree.d.ts.map